import { defineStore } from "pinia";

const STORAGE_KEY = "selectedVenueId";

function readFromStorage(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === null || raw === "" ? null : raw;
  } catch {
    return null;
  }
}

function writeToStorage(id: string | null) {
  try {
    if (id === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, String(id));
  } catch {
    // ignore storage errors (e.g. privacy mode)
  }
}

export const useVenueStore = defineStore("venues", {
  state: () => ({
    // canonical stored value is a venue id (string) or null
    venue_id: readFromStorage() as string | null,
  }),

  actions: {
    setVenue(venue: any) {
      // accept either an id string or an object with id/value
      let id: string | null = null;
      if (venue === null || venue === undefined) {
        id = null;
      } else if (typeof venue === "string") {
        id = venue;
      } else if (typeof venue === "object") {
        id = String(venue.id ?? venue.value ?? null);
        if (id === "null") id = null;
      } else {
        id = String(venue);
      }

      this.venue_id = id;
      writeToStorage(id);
    },

    clearVenue() {
      this.venue_id = null;
      writeToStorage(null);
    },
  },
});